import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';
import { DateTime } from 'luxon';

@MappedClass()
export class CheckAstatDailyGuestsInClosurePeriodRequest {
  @MappedPropertyDate()
  closureBeginDate: DateTime;

  @MappedPropertyDate()
  closureEndDate: DateTime;

  @MappedProperty()
  ownerIstatId: number;
}
